var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticStyle:{"padding":"24px","text-align":"justify"}},[_vm._v("\n  "+_vm._s(_vm.content)+" \n")])
}
var staticRenderFns = []

export { render, staticRenderFns }